<mat-card class="flex flex-col gap-3">
  <div class="flex flex-row">
    <mat-card-title>Manually "Start Reporting" for a Service Center</mat-card-title>
    <span class="flex-1"></span>
    <button type="button" mat-flat-button color="warn" (click)="cancel()">Close</button>
  </div>
  <div class="flex flex-row">
    <mat-card-content>
      <div class="flex flex-col gap-4">
        <span style="font-size: 16px;">Use this option to allow a service center to report when they have not clicked "Start Reporting" during a designated reporting period.</span>
        <span style="font-size: 16px;">If the license number shows up in the 303 Client Data and 303 Service Center data sections for the reporting period in question, do not use this button- the
          service center has already begun reporting.</span>
        <span style="font-size: 16px;">Enter a date range that matches the reporting window (4/1-4/25; 7/1-7/25; 10/1-10/25; 1/1-1/25).</span>

        <span style="font-size: 16px;"><i>Only select the "Partial Quarter" option if managers instructed you to do so. The purpose of partial quarter reporting is so that service centers who will be closed
          for a substantive period of time or will otherwise not be licensed during an entire quarter can report the data for the actual days they are licensed during that quarter. Selecting this option
          makes a new field appear for the selected reporting window on the service center data tab on the public side 303 reporting portal.</i></span>
      </div>
    </mat-card-content>
  </div>
  <div class="flex flex-row w-[100%]">
    <form [formGroup]="createReportForm" class="flex gap-4 w-[100%] items-center">

      <mat-form-field class="w-[30%]">
        <mat-label>License Id</mat-label>
        <input matInput type="text" formControlName="licenseId" placeholder="License Id">
        <mat-error *ngIf="createReportForm.get('licenseId').hasError('required')">
          License Id is required
        </mat-error>
      </mat-form-field>

      <mat-form-field class="max-md:w-[100%]">
        <mat-label>Begin</mat-label>
        <input placeholder="mm/dd/yyyy" formControlName="from" matInput [matDatepicker]="from" />
        <mat-datepicker-toggle matSuffix [for]="from"></mat-datepicker-toggle>
        <mat-datepicker #from>
          <mat-datepicker-actions>
            <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
            <button mat-button matDatepickerCancel>Cancel</button>
          </mat-datepicker-actions>
        </mat-datepicker>
        <mat-error *ngIf="createReportForm.get('from').hasError('required')">
          Begin date is required
        </mat-error>
      </mat-form-field>

      <mat-form-field class="max-md:w-[100%]">
        <mat-label>End</mat-label>
        <input placeholder="mm/dd/yyyy" formControlName="to" matInput [matDatepicker]="to" />
        <mat-datepicker-toggle matSuffix [for]="to"></mat-datepicker-toggle>
        <mat-datepicker #to>
          <mat-datepicker-actions>
            <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
            <button mat-button matDatepickerCancel>Cancel</button>
          </mat-datepicker-actions>
        </mat-datepicker>
        <mat-error *ngIf="createReportForm.get('to').hasError('required')">
          End date is required
        </mat-error>
      </mat-form-field>

      <mat-checkbox formControlName="partialQuarter">Partial Quarter</mat-checkbox>
    </form>
  </div>
  <div class="flex flex-row justify-center items-center">
    <button type="button" mat-flat-button color="primary" (click)="createReport()" [disabled]="!createReportForm.valid || isCreatingReport">
      {{ isCreatingReport ? 'Creating Report...' : 'Open Data Reporting Portal' }}
    </button>
  </div>
</mat-card>
